import teammemberCommitmentStatus from "../definitions/teammemberCommitmentStatus";
import {CommitmentStatus, TestUserEmailPath} from "../definitions/constants";
import { CommitmentModelAdminApprovalEnum, CommitmentModelStatusV2Enum } from "../services/openApi";

export default class Infrastructure {
  public static isTestingUser(email: string): boolean{
    var emailPath = email.split("@")[1].toLowerCase();
    return emailPath === TestUserEmailPath;
  }

  public static getTeammemberCommitmentStatus(status: number) : string {
      switch (status) {
          case teammemberCommitmentStatus.active:
            return CommitmentStatus.active
            break;
          case teammemberCommitmentStatus.upcomming:
            return CommitmentStatus.upcomming
            break;
          default:
            return CommitmentStatus.expire
            break;
        }
  }

  public static checkCommitmentStatus(status: CommitmentModelStatusV2Enum | undefined) {
    switch (status) {
      case CommitmentModelStatusV2Enum.Active:
        return {"color": "success", "value": "Active", "index": 0};
      case CommitmentModelStatusV2Enum.AdminPending:
      case CommitmentModelStatusV2Enum.CustomerPending:
      case CommitmentModelStatusV2Enum.TeammemberPending:
        return {"color": "yellow", "value": "Pending", "index": 1};
      case CommitmentModelStatusV2Enum.Upcoming:
        return {"color": "orange", "value": "Upcoming", "index": 2};
      case CommitmentModelStatusV2Enum.AdminRejected:
      case CommitmentModelStatusV2Enum.CustomerRejected:
      case CommitmentModelStatusV2Enum.TeammemberRejected:
        return {"color": "error", "value": "Rejected", "index": 3};
      case CommitmentModelStatusV2Enum.Expired:
        return {"color": "grey", "value": "Expired", "index": 4};
      default:
        return {"color": "success", "value": "Active", "index": 0};
    }
  }

  public static checkApprovalStatus(status: CommitmentModelAdminApprovalEnum | undefined) {
    switch (status) {
      case CommitmentModelAdminApprovalEnum.ApprovedExplicit:
      case CommitmentModelAdminApprovalEnum.ApprovedInherited:
        return {"color": "success", "value": status};
      case CommitmentModelAdminApprovalEnum.Pending:
        return {"color": "yellow", "value": "Pending"};
      case CommitmentModelAdminApprovalEnum.Rejected:
        return {"color": "error", "value": "Rejected"};
      default:
        return {"color": "grey", "value": "Not Set"};
    }
  }

}